/**
 * Implements connect wallet modal
 */
import { useState } from 'react';
import { Connector } from 'wagmi';
import ConnectorWallets from './ConnectorWallets';
import SubWalletsModal from './SubWallets';

import './styles.scss';

export interface ISubWallet {
  id: string;
  image: string;
  title: string;
  isLink: boolean;
}

export type GetSubWallets = () => Promise<ISubWallet[]> | ISubWallet[];
export type SetCurrentWallet = (id: string) => void;

export interface ISubWalletConnectorOptions {
  getSubWallets: GetSubWallets;
  setCurrentWallet: SetCurrentWallet;
}

export interface ISubModalState {
  wallets: ISubWallet[];
  connector: Connector<any, ISubWalletConnectorOptions>;
}

interface props {
  onCancel: () => void;
}

const ConnectModal = ({ onCancel }: props) => {
  const [subModal, setSubModal] = useState<ISubModalState>();

  return (
    <div className='connect_modal no_scroll'>
      <div className='connect_modal__header'>
        <div className='connect_modal__header__caption'>Connect Wallet</div>
        <div className='connect_modal__header__close' onClick={onCancel} />
      </div>
      {subModal ? (
        <SubWalletsModal
          wallets={subModal.wallets}
          connector={subModal.connector}
          onCancel={onCancel}
          onBack={() => setSubModal(undefined)}
        />
      ) : (
        <ConnectorWallets onCancel={onCancel} setSubModal={setSubModal} />
      )}
    </div>
  );
};

export default ConnectModal;
